import { capturePostHogEvent } from './posthogClient';

export function captureWorkQueueCountersView() {
  try {
    capturePostHogEvent('engage-view-work-queue-counters');
  } catch {
    // Analytics must not break the Key Metrics dashboard.
  }
}

export function captureWorkQueueCounterClick(queue) {
  try {
    capturePostHogEvent('engage-click-work-queue', { queue });
  } catch {
    // Analytics must not break queue navigation.
  }
}
